export function formatShortDate(
  value: string | number | Date | null | undefined,
  language = "fr"
): string {
  if (!value) {
    return "";
  }

  const date = new Date(String(value).replace(" ", "T"));
  if (Number.isNaN(date.getTime())) {
    return String(value);
  }

  return new Intl.DateTimeFormat(language || "fr", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(date);
}
